module.exports = __webpack_public_path__ + "static/media/APP_TimeMagician_152x174_4.a52e994e.png";